var _rect, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOccupiedFreeMaleFemaleE(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_34_274",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    fill: "#D9D9D9",
    stroke: "#1CADE4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_34_274)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    stroke: "#1CADE4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.1301,
    y: -14.412,
    width: 55.0175,
    height: 48,
    transform: "rotate(17.2535 39.1301 -14.412)",
    fill: "#ED6F8D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7173 14V6.72727H49.4474V7.83168H46.0348V9.80611H49.2024V10.9105H46.0348V12.8956H49.4759V14H44.7173Z",
    fill: "#090F23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOccupiedFreeMaleFemaleE);
export default __webpack_public_path__ + "static/media/occupied-free-male-female-e.ca3973805cea77f66e5ac821d966246c.svg";
export { ForwardRef as ReactComponent };